import Content404 from '../Components/404/Content404';

function Notfound() {
    return (
        <>
            <Content404/>
        </>
    );
}
export default  Notfound;